//This Function will adjust navigation location (always middle)
function adjustNavLocation() {
	$(window).height();
	$('#leftnav-global').height();
	window_height = parseInt($(window).height()/2);
	nav_height = parseInt($('#leftnav-global').height() / 2);
	topLocation = window_height - nav_height;
	$('#leftnav-global').css("position", "fixed");
	$('#leftnav-global').css("top", (topLocation) + "px");
}

//first load
adjustNavLocation();

//On scroll
$( window ).scroll(function() {
  adjustNavLocation();
});
//On resize
$(window).resize(function(e) {
    adjustNavLocation();
});

// Cookies
function createCookie(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}
//Read Cookie
function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
//Erase Cookie
function eraseCookie(name) {
  createCookie(name,"",-1);
}
//
$("#shareShowHide").click(function(e) {
  $( ".addtocart-right .social-sharing" ).slideToggle( "slow" );
});

$("#altImageToggleLink").click(function (e){
  if($( "#altImageHolder" ).css("display") == "none"){
  	$("#altImageToggleLink").addClass("active");
  } else {
  	$("#altImageToggleLink").removeClass("active");
  }
  $( "#altImageHolder" ).slideToggle( "slow" );
});

//eraseCookie("mc_popup");
$(document).ready(function(e){
  isShown = readCookie("mc_popup");
  // console.log(isShown);
  if(!popup_test_mode){
    if(isShown != '1'){
      createCookie("mc_popup", '1', 1);	
      window.location.href = "#popup1";
    }
  } else {
     window.location.href = "#popup1";
  }
});

// swiper slider

$(document).ready(function() {
  //initialize swiper when document ready  
  var swiper = new Swiper('.swiper-container', {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    loop: true,
    autoplay: 6000,
    nextButton: '.next',
    prevButton: '.prev'
  })
 
  setPaginationHeight();
  setProductSlideHeight();

});

$(window).resize(function(e) {
  setPaginationHeight();
  setProductSlideHeight();
});

// finds window height
var windowHeight = $(window).height();

// finds window width
var windowWidth = $(window).width();

// product page swiper
function setProductSlideHeight() {
  if ($('body').hasClass('Product')) {
    var productSliderContainerHeight = $(".swiper-container").outerHeight();
    $(".productphotos").css("height", productSliderContainerHeight);
    $(".swiper-slide").css("background-size", windowHeight);
    $(".swiper-slide img").css("height", windowHeight);
  };
}

// Sets pagination height by finding the footer size
function setPaginationHeight() {
  var footerHeight = $("footer").outerHeight() + 10;

  if ($('body').hasClass('Home')) {
    $(".swiper-container-horizontal>.swiper-pagination").css("bottom", footerHeight);
  };
}